import React from "react";
import styled from "styled-components";
import {
  Badge,
  ButtonBase,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { DatePicker as Selector } from "@mui/lab";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";

export const CameraIcon = styled(PhotoCameraIcon)`
  && {
    width: 25px;
    height: 25px;
    cursor: pointer;
    background: #f2753b;
    border-radius: 50%;
    padding: 7px;
    color: white;
  }
`;

export const Title = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 44px;
    letter-spacing: 0.05em;
    color: #000000;
    margin-bottom: 17px;
  }
`;

export const InputLabel = styled(Typography)`
  && {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.05em;
    color: #000000;
    margin-bottom: 10px;
  }
`;

export const InputField = styled(TextField)`
  && {
    .MuiOutlinedInput-root {
      height: 50px;
      padding: 0px 6px;
      border-radius: 10px;
      background: #ffffff;
      color: gray;
      & > fieldset {
        border: none;
      }
    }
  }
`;

export const SumbitButton = styled(ButtonBase)`
  && {
    width: 175px;
    height: 50px;
    background: #f2753b;
    box-shadow: -2px 2px 2px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    text-transform: capitalize;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #ffffff;
    margin-top: 50px;
  }
`;

export const UserName = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    letter-spacing: 0.05em;
    color: #000000;
    text-align: center;
    margin-bottom: 7px;
  }
`;

export const UserEmail = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0.05em;
    color: #000000;
    text-align: center;
  }
`;

export const ProfileImage = styled(Badge)`
  && {
    width: 168px;
    height: 168px;
    position: relative;
    bottom: 100px;
    left: 20%;
    margin-bottom: -87px;
  }
`;

export const InputTextField = (props) => {
  return (
    <InputField
      disabled={props.type === "email" || props.type === "text" ? true : false}
      onChange={(e) => props.setValue(e.target.value)}
      value={props.value}
      placeholder={props.label}
      type={props.type || "text"}
      sx={{ width: { xs: "100%", md: props.address || 400 } }}
    />
  );
};

export const DatePicker = (props) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Selector
        disableFuture
        openTo="year"
        views={["year", "month", "day"]}
        value={props.value}
        onChange={(newValue) => props.setValue(newValue)}
        renderInput={(params) => (
          <TextField sx={{ width: "100%" }} {...params} />
        )}
      />
    </LocalizationProvider>
  );
};

export const GenderSelector = (props) => {
  return (
    <Select
      value={props.value}
      onChange={(e) => props.setValue(e.target.value)}
    >
      <MenuItem className="profile-menu" value={"other"}>Other</MenuItem>
      <MenuItem className="profile-menu" value={"female"}>Female</MenuItem>
      <MenuItem className="profile-menu" value={"male"}>Male</MenuItem>
    </Select>
  );
};
